// ** React Imports
import { Link, useParams } from 'react-router-dom'

// ** Third Party Components
import Proptypes from 'prop-types'
import { useDispatch } from 'react-redux'
import {
  Breadcrumb,
  BreadcrumbItem
} from 'reactstrap'
import { handleCleanForm } from '../../../redux/actions/form'
import { useRedirect } from '../../../utility/hooks/useRedirect'
import { useSubmit } from '../../../utility/hooks/useSubmit'
import { ActionButtons } from '../actionButtons/ActionButtons'


const BreadCrumbs = props => {
  // ** Props
  const { breadCrumbTitle, breadCrumbParent, breadCrumbParent2, breadCrumbParent3, breadCrumbActive = breadCrumbTitle } = props
  const { handleSubmit, onSubmit, onCancel, buttonStyles, endPoint, extraOptions } = props

  const dispatch = useDispatch()
  const { id } = useParams()
  const redirect = useRedirect(id)
  const submitValidations = useSubmit(endPoint, id)

  const handleGoBack = () => {
    dispatch(handleCleanForm())
    redirect.redirectToList()
  }

  return (
    <div className='content-header row'>
      <div className='content-header-left col-md-8 col-12 mb-2'>
        <div className='row breadcrumbs-top'>
          <div className='col-12'>
            {breadCrumbTitle ? <h3 className='content-header-title float-left mb-0'>{breadCrumbTitle}</h3> : ''}
            <div className='breadcrumb-wrapper vs-breadcrumbs d-sm-block d-none '>
              <Breadcrumb key='breadcrumb'>
                <BreadcrumbItem tag='li'>
                  <Link to='/'>Inicio</Link>
                </BreadcrumbItem>
                <BreadcrumbItem tag='li' className='text-primary' style={{ cursor: 'Pointer' }} onClick={() => { handleGoBack() }}>
                  {breadCrumbParent}
                </BreadcrumbItem>
                {breadCrumbParent2 && (
                  <BreadcrumbItem tag='li' className='text-primary'>
                    {breadCrumbParent2}
                  </BreadcrumbItem>
                )}
                {breadCrumbParent3 && (
                  <BreadcrumbItem tag='li' className='text-primary'>
                    {breadCrumbParent3}
                  </BreadcrumbItem>
                )}
                <BreadcrumbItem tag='li' active>
                  {breadCrumbActive}
                </BreadcrumbItem>
              </Breadcrumb>
            </div>

          </div>
        </div>
      </div>
      <div className='col-md-4 col-12 mb-2 d-flex justify-content-end'>
        <ActionButtons onSubmit={handleSubmit || submitValidations[onSubmit || 'submit']} onCancel={onCancel} endPoint={endPoint} styles={buttonStyles} extraOptions={extraOptions} />
      </div>
    </div>
  )
}
export default BreadCrumbs

// ** PropTypes
BreadCrumbs.propTypes = {
  breadCrumbTitle: Proptypes.string.isRequired
}
